import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-718598a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "roles-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "roles-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "header-info" }, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Configuración de Roles"),
    /*#__PURE__*/ _createElementVNode("p", { class: "subtitle" }, "Administra los niveles de acceso y permisos del sistema")
], -1 /* HOISTED */));
const _hoisted_6 = {
    key: 0,
    class: "header-actions"
};
const _hoisted_7 = {
    key: 0,
    class: "roles-grid"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "role-icon" };
const _hoisted_10 = { class: "role-details" };
const _hoisted_11 = {
    key: 0,
    class: "role-card-actions"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
    key: 1,
    class: "role-arrow"
};
const _hoisted_15 = {
    key: 1,
    class: "permissions-panel animate__animated animate__fadeInUp"
};
const _hoisted_16 = { class: "panel-header" };
const _hoisted_17 = { class: "panel-title" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Marca los permisos que deseas otorgar a este rol", -1 /* HOISTED */));
const _hoisted_19 = { class: "panel-actions" };
const _hoisted_20 = ["disabled"];
const _hoisted_21 = { class: "permissions-groups" };
const _hoisted_22 = { class: "group-title" };
const _hoisted_23 = { class: "permission-items" };
const _hoisted_24 = { class: "checkbox-container" };
const _hoisted_25 = ["value"];
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "checkmark" }, null, -1 /* HOISTED */));
const _hoisted_27 = { class: "perm-info" };
const _hoisted_28 = { class: "perm-name" };
const _hoisted_29 = { class: "perm-code" };
const _hoisted_30 = {
    key: 2,
    class: "loading-state"
};
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Cargando roles y permisos...", -1 /* HOISTED */));
const _hoisted_32 = { class: "modal-window" };
const _hoisted_33 = { class: "modal-header" };
const _hoisted_34 = { class: "modal-title-group" };
const _hoisted_35 = { class: "icon-bg" };
const _hoisted_36 = { class: "modal-title" };
const _hoisted_37 = { class: "form-group premium-input" };
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre del Rol", -1 /* HOISTED */));
const _hoisted_39 = { class: "modal-footer" };
const _hoisted_40 = ["disabled"];
import { ref, onMounted, computed } from 'vue';
import Header from '@/components/HeaderDashboard.vue';
import Sidebar from '@/components/Sidebar.vue';
import { PermissionService } from '@/services/PermissionService';
import { ShieldCheckIcon, UserCheckIcon, UserIcon, ChevronRightIcon, Settings2Icon, SaveIcon, Loader2Icon, PlusIcon, PencilIcon, Trash2Icon, XIcon, TruckIcon } from 'lucide-vue-next';
import Swal from 'sweetalert2';
import { hasPermission } from '@/store/userStore';
import { PERMISSIONS } from '@/constants/permissions';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const roles = ref([]);
        const permissions = ref([]);
        const loading = ref(true);
        const P = PERMISSIONS;
        const can = hasPermission;
        const saving = ref(false);
        const selectedRol = ref(null);
        const selectedPermissionIds = ref([]);
        // Modal State para Roles
        const isRoleModalOpen = ref(false);
        const isEditingRole = ref(false);
        const roleForm = ref({ nombre: '' });
        const isSubmittingRole = ref(false);
        const selectedRolForEdit = ref(null);
        const loadData = async () => {
            loading.value = true;
            try {
                const [rolesRes, permsRes] = await Promise.all([
                    PermissionService.getRoles(),
                    PermissionService.getAllPermissions()
                ]);
                // Manejar estructura ApiResponse
                roles.value = rolesRes?.datos || rolesRes?.Datos || (Array.isArray(rolesRes) ? rolesRes : []);
                permissions.value = permsRes?.datos || permsRes?.Datos || (Array.isArray(permsRes) ? permsRes : []);
                // Si ya teníamos un rol seleccionado, actualizarlo en la lista
                if (selectedRol.value) {
                    const updated = roles.value.find(r => r.rolId === selectedRol.value?.rolId);
                    if (updated)
                        selectRol(updated);
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                loading.value = false;
            }
        };
        const selectRol = (rol) => {
            selectedRol.value = rol;
            selectedPermissionIds.value = rol.permisos?.map(p => p.permisoId) || [];
        };
        const groupedPermissions = computed(() => {
            const groups = {};
            permissions.value.forEach(p => {
                const catName = p.modulo || 'Otros';
                if (!groups[catName])
                    groups[catName] = [];
                groups[catName].push(p);
            });
            return groups;
        });
        const savePermissions = async () => {
            if (!selectedRol.value)
                return;
            saving.value = true;
            try {
                const res = await PermissionService.updateRolPermissions(selectedRol.value.rolId, selectedPermissionIds.value);
                if (res.exito) {
                    Swal.fire('¡Éxito!', 'Permisos actualizados correctamente', 'success');
                    await loadData();
                }
                else {
                    throw new Error(res.mensaje);
                }
            }
            catch (error) {
                Swal.fire('Error', error.message || 'No se pudieron guardar los permisos', 'error');
            }
            finally {
                saving.value = false;
            }
        };
        const seedPermissions = async () => {
            try {
                const res = await PermissionService.seedPermissions();
                if (res.exito) {
                    Swal.fire('¡Éxito!', 'Sistema inicializado', 'success');
                    loadData();
                }
                else {
                    Swal.fire('Info', res.mensaje || 'Ya inicializado', 'info');
                }
            }
            catch (error) {
                Swal.fire('Error', 'Hubo un error al inicializar', 'error');
            }
        };
        const createNewRol = () => {
            isEditingRole.value = false;
            roleForm.value.nombre = '';
            selectedRolForEdit.value = null;
            isRoleModalOpen.value = true;
        };
        const editRolName = (rol) => {
            isEditingRole.value = true;
            roleForm.value.nombre = rol.nombre;
            selectedRolForEdit.value = rol;
            isRoleModalOpen.value = true;
        };
        const closeRoleModal = () => {
            isRoleModalOpen.value = false;
        };
        const saveRole = async () => {
            if (!roleForm.value.nombre)
                return;
            isSubmittingRole.value = true;
            try {
                let res;
                if (isEditingRole.value && selectedRolForEdit.value) {
                    res = await PermissionService.updateRol(selectedRolForEdit.value.rolId, roleForm.value.nombre);
                }
                else {
                    res = await PermissionService.createRol(roleForm.value.nombre);
                }
                if (res.exito) {
                    Swal.fire('¡Éxito!', isEditingRole.value ? 'Rol actualizado correctamente' : 'El nuevo rol ha sido creado', 'success');
                    isRoleModalOpen.value = false;
                    loadData();
                }
                else {
                    Swal.fire('Error', res.mensaje || 'No se pudo procesar la solicitud', 'error');
                }
            }
            catch (error) {
                Swal.fire('Error', 'Ocurrió un error inesperado al guardar el rol', 'error');
            }
            finally {
                isSubmittingRole.value = false;
            }
        };
        const deleteRol = async (rol) => {
            const result = await Swal.fire({
                title: '¿Eliminar Rol?',
                text: `Se eliminará el rol "${rol.nombre}". Esta acción no se puede deshacer si tiene usuarios asociados.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });
            if (result.isConfirmed) {
                try {
                    const res = await PermissionService.deleteRol(rol.rolId);
                    if (res.exito) {
                        Swal.fire('Eliminado', 'El rol ha sido borrado', 'success');
                        if (selectedRol.value?.rolId === rol.rolId) {
                            selectedRol.value = null;
                        }
                        loadData();
                    }
                    else {
                        Swal.fire('Error', res.mensaje || 'No se pudo eliminar', 'error');
                    }
                }
                catch (error) {
                    Swal.fire('Error', 'Error al intentar eliminar el rol', 'error');
                }
            }
        };
        onMounted(() => {
            loadData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Sidebar),
                    _createElementVNode("main", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            (!loading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (_unref(can)(_unref(P).ROLES.MANAGE))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: createNewRol,
                                            class: "btn btn-primary"
                                        }, [
                                            _createVNode(_unref(PlusIcon), { size: 18 }),
                                            _createTextVNode(" Nuevo Rol ")
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        (!loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createCommentVNode(" Tarjeta de cada Rol "),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (rol) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: rol.rolId,
                                        class: _normalizeClass(["role-card", { active: selectedRol.value?.rolId === rol.rolId }]),
                                        onClick: ($event) => (selectRol(rol))
                                    }, [
                                        _createElementVNode("div", _hoisted_9, [
                                            (rol.rolId === 1)
                                                ? (_openBlock(), _createBlock(_unref(ShieldCheckIcon), {
                                                    key: 0,
                                                    size: 32,
                                                    color: "#3b82f6",
                                                    title: "Administrador"
                                                }))
                                                : (rol.rolId === 2)
                                                    ? (_openBlock(), _createBlock(_unref(UserCheckIcon), {
                                                        key: 1,
                                                        size: 32,
                                                        color: "#10b981",
                                                        title: "Comprador"
                                                    }))
                                                    : (rol.rolId === 3)
                                                        ? (_openBlock(), _createBlock(_unref(TruckIcon), {
                                                            key: 2,
                                                            size: 32,
                                                            color: "#f59e0b",
                                                            title: "Proveedor"
                                                        }))
                                                        : (_openBlock(), _createBlock(_unref(UserIcon), {
                                                            key: 3,
                                                            size: 32,
                                                            color: "#6b7280"
                                                        }))
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("h3", null, _toDisplayString(rol.nombre), 1 /* TEXT */),
                                            _createElementVNode("p", null, _toDisplayString(rol.permisos?.length || 0) + " permisos asignados", 1 /* TEXT */)
                                        ]),
                                        (_unref(can)(_unref(P).ROLES.MANAGE) && rol.rolId > 3)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _createElementVNode("button", {
                                                    onClick: _withModifiers(($event) => (editRolName(rol)), ["stop"]),
                                                    class: "btn-icon-small",
                                                    title: "Editar nombre"
                                                }, [
                                                    _createVNode(_unref(PencilIcon), { size: 16 })
                                                ], 8 /* PROPS */, _hoisted_12),
                                                _createElementVNode("button", {
                                                    onClick: _withModifiers(($event) => (deleteRol(rol)), ["stop"]),
                                                    class: "btn-icon-small btn-delete",
                                                    title: "Eliminar rol"
                                                }, [
                                                    _createVNode(_unref(Trash2Icon), { size: 16 })
                                                ], 8 /* PROPS */, _hoisted_13)
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                _createVNode(_unref(ChevronRightIcon), { size: 20 })
                                            ]))
                                    ], 10 /* CLASS, PROPS */, _hoisted_8));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Panel de Permisos del Rol Seleccionado "),
                        (selectedRol.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                        _createVNode(_unref(Settings2Icon), { size: 24 }),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("h2", null, "Permisos para: " + _toDisplayString(selectedRol.value.nombre), 1 /* TEXT */),
                                            _hoisted_18
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("button", {
                                            onClick: _cache[0] || (_cache[0] = ($event) => (selectedRol.value = null)),
                                            class: "btn btn-secondary",
                                            title: "Cerrar panel"
                                        }, [
                                            _createVNode(_unref(XIcon), { size: 18 }),
                                            _createTextVNode(" Cancelar ")
                                        ]),
                                        (_unref(can)(_unref(P).ROLES.MANAGE))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: savePermissions,
                                                class: "btn btn-primary",
                                                disabled: saving.value
                                            }, [
                                                (!saving.value)
                                                    ? (_openBlock(), _createBlock(_unref(SaveIcon), {
                                                        key: 0,
                                                        size: 18
                                                    }))
                                                    : (_openBlock(), _createBlock(_unref(Loader2Icon), {
                                                        key: 1,
                                                        size: 18,
                                                        class: "spinner"
                                                    })),
                                                _createTextVNode(" " + _toDisplayString(saving.value ? 'Guardando...' : 'Guardar Cambios'), 1 /* TEXT */)
                                            ], 8 /* PROPS */, _hoisted_20))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedPermissions.value, (group, category) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: category,
                                            class: "permission-group"
                                        }, [
                                            _createElementVNode("h4", _hoisted_22, _toDisplayString(category), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_23, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (perm) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: perm.permisoId,
                                                        class: "permission-item"
                                                    }, [
                                                        _createElementVNode("label", _hoisted_24, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "checkbox",
                                                                value: perm.permisoId,
                                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedPermissionIds).value = $event))
                                                            }, null, 8 /* PROPS */, _hoisted_25), [
                                                                [_vModelCheckbox, selectedPermissionIds.value]
                                                            ]),
                                                            _hoisted_26,
                                                            _createElementVNode("div", _hoisted_27, [
                                                                _createElementVNode("span", _hoisted_28, _toDisplayString(perm.nombre), 1 /* TEXT */),
                                                                _createElementVNode("span", _hoisted_29, _toDisplayString(perm.codigo), 1 /* TEXT */)
                                                            ])
                                                        ])
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createVNode(_unref(Loader2Icon), {
                                    size: 48,
                                    class: "spinner"
                                }),
                                _hoisted_31
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Modal para Crear/Editar Rol (Diseño Premium tipo Categoría) "),
                        _createVNode(_Transition, { name: "modal-fade" }, {
                            default: _withCtx(() => [
                                (isRoleModalOpen.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "modal-overlay",
                                        onClick: _withModifiers(closeRoleModal, ["self"])
                                    }, [
                                        _createElementVNode("div", _hoisted_32, [
                                            _createElementVNode("div", _hoisted_33, [
                                                _createElementVNode("div", _hoisted_34, [
                                                    _createElementVNode("div", _hoisted_35, [
                                                        (!isEditingRole.value)
                                                            ? (_openBlock(), _createBlock(_unref(PlusIcon), {
                                                                key: 0,
                                                                size: 22,
                                                                class: "text-primary"
                                                            }))
                                                            : (_openBlock(), _createBlock(_unref(PencilIcon), {
                                                                key: 1,
                                                                size: 22,
                                                                class: "text-primary"
                                                            }))
                                                    ]),
                                                    _createElementVNode("h2", _hoisted_36, _toDisplayString(isEditingRole.value ? 'Editar Rol' : 'Nuevo Rol'), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("button", {
                                                    onClick: closeRoleModal,
                                                    class: "btn-close-modal"
                                                }, [
                                                    _createVNode(_unref(XIcon), { size: 22 })
                                                ])
                                            ]),
                                            _createElementVNode("form", {
                                                onSubmit: _withModifiers(saveRole, ["prevent"]),
                                                class: "modal-body"
                                            }, [
                                                _createElementVNode("div", _hoisted_37, [
                                                    _hoisted_38,
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((roleForm.value.nombre) = $event)),
                                                        placeholder: "Ej: Vendedor, Supervisor, Soporte...",
                                                        required: "",
                                                        class: "form-control"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [_vModelText, roleForm.value.nombre]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_39, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        onClick: closeRoleModal,
                                                        class: "btn-cancel-modal"
                                                    }, "Cancelar"),
                                                    _createElementVNode("button", {
                                                        type: "submit",
                                                        class: "btn-save-modal",
                                                        disabled: isSubmittingRole.value
                                                    }, _toDisplayString(isSubmittingRole.value ? 'Guardando...' : (isEditingRole.value ? 'Actualizar' :
                                                        'Registrar')), 9 /* TEXT, PROPS */, _hoisted_40)
                                                ])
                                            ], 32 /* NEED_HYDRATION */)
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]));
        };
    }
});
